// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__2dVjU","avatar":"Panel_avatar__flq00","brand":"Panel_brand__dyosW","share":"Panel_share__3jz0a","counter":"Panel_counter__3CqUN"};